import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { PublicDataContext } from "./lib/publicData";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PublicDataContext.Provider value={window.__STUDIO_DATA__ || {}}><App /></PublicDataContext.Provider>
  </React.StrictMode>,
);
